var $c561931cbd544a49$exports = {};
$c561931cbd544a49$exports = {
    "breadcrumbs": `\u{5C0E}\u{89BD}\u{5217}`
};


export {$c561931cbd544a49$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
